import { showMenu } from 'actions/layout'
import { getUserProfileDetails } from 'actions/profileNew'
import { applyPromoCheckout, checkLiveCourse, fetchPromoCodes, getCheckOutItem, getCheckPayment, getCouponList, payNowCart, postAddSaveForLater, postAddSaveItem, postCartPayment, removeSaveItem, setCouponInCart, setCouponList, setPromoCode, setPromoManuallyRemoved, setSelectedCouponCode, setSelectedTerm, setStorePayTerm, setStorePromoPrice, setTermList, setValueForCheckout, storeCourseIdAndType, storeSelectedPlan } from 'actions/studentMarketPlace'
import { Input, Tooltip, Select } from 'antd'
import { Button } from 'components/Button'
import PageDataLoader from 'components/pageDataLoader'
import moment from 'moment'
// import { generatePaymentRequest } from 'pages/profile/paymentGateway'
import { redirectToPayU, openPayuLoadingWindow } from 'pages/profile/paymentGateway'
import React, { useEffect, useRef, useState } from 'react'
import HtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Api, Notification } from 'services'
import saveFill from "../../Assets/aulasMarket/saveFilledIcon.svg"
import saveOutlined from "../../Assets/aulasMarket/saveOutlineColorIcon.svg"
import CouponsModal from './couponsModal'
import { InvalidCouponMessage, InvalidCouponType, getBestPromoCode } from './constants/studentMarketPlace';
import CourseInstallmentModal from './coursePageCompo/courseInstallment'
import Footer from './footer'
import MobileCheckOut from './mobileCheckOut'
import MobilePageHeader from './mobilePageHeader'
import RatingStars from './ratingStars'
import "./saveForLater.css"
import "./studentCart.css"
import TopBar from './topBar'
import NewFooter from './newFooter'
import DownloadAppModal from './downloadAppModal'
import OfferCarouselV2 from './offerCarouselV2'
import PaymentDetailsModal, { getMissingPaymentDetails, formatBillingAddress } from 'components/paymentDetailsModal'
const defaultCourseImage = require('Assets/default_course-img.svg').default;

const PAYU_WINDOW_NAME = 'payuPaymentWindow';

function StudentCheckOut({ singleBuyNowDetails, setStorePayTerm, storePayTerm, selectedTerm, setSelectedTerm, setStorePromoPrice, setTermList, promoManuallyRemoved, setPromoManuallyRemoved,
    termList, couponList, setSelectedCouponCode, selectedCouponCode, checkLiveCourse, getCouponList, setCouponList, removeSaveItem,
    postAddSaveItem, applyPromoCheckout, postCartPayment, getCheckPayment, couponInCart, postAddSaveForLater, fetchPromoCodes,
    promoCodeDetials, user, cartDetails, payNowCart, setLoader, loginDetails, setCouponInCart, storePromoPrice, offersCarouselData,
    showMenu, setValueForCheckout, getCheckOutItem, isDownloadBarVisible, showContactBar, storeCourseIdAndType, isOffersBarVisible, userMarketPlaceHomeData, selectedPlan, storeSelectedPlan, userDetails, getUserProfileDetails }) {
    const [applyLoader, toggleApplyLoader] = useState(false);
    const [paynowLoader, togglePaynowLoader] = useState(false);
    const [profileLoader, toggleProfileLoader] = useState(true);
    const history = useHistory();
    const [payOfferCode, setPayOfferCode] = useState(null);
    const [isCouponModal, setIsCouponModal] = useState(false);
    const [isInputTyped, setIsInputTyped] = useState(false);
    const [isInstallmentVisible, setInstallmentVisible] = useState(false);
    const location = useLocation();
    const [pageLoader, togglePageLoader] = useState(false);
    const [courseBatches, setCourseBatches] = useState([]);
    const [selectedBatchId, setSelectedBatchId] = useState(null);
    const { itemId, itemType, closeInstallmentModal, promo } = location.state || {};
    const [isPayTerm, setIsPayTerm] = useState(selectedTerm || singleBuyNowDetails?.billingPlan);
    const [planName, setPlanName] = useState( selectedPlan || singleBuyNowDetails?.selectedPlan);
    const [invalidCouponType, setInvalidCouponType] = useState(null);
    const [disablePay, setDisablePay] = useState(false);
    const [showDownloadAppModal, setShowDownloadAppModal] = useState(false)
    const [fromCheckoutPage, setFromCheckoutPage] = useState(false)
    const [isPaymentDetailsModal, setIsPaymentDetailsModal] = useState(false);
    const payuWindowRef = useRef(null);
    const pendingPaymentRef = useRef(null);
    // Details collected by the payment-details modal for this attempt. Kept in a ref so a user who
    // supplied them without ticking "save" is not asked again on a retry within the same visit.
    const paymentDetailsRef = useRef(null);

    useEffect(() => {
        const checkPaymentWindowClosed = () => {
            if (pendingPaymentRef.current && payuWindowRef.current?.closed) {
                const object = pendingPaymentRef.current;
                pendingPaymentRef.current = null;
                togglePaynowLoader(true);
                const query = new URLSearchParams({
                    orderId: object.orderId,
                    status: 'success',
                    type: object.type || '',
                    id: object.id || '',
                    billingPlan: object.billingPlan || '',
                    planName: object.planName || '',
                    promo: object.promo || '',
                    standardId: object.standardId || '',
                    from: 'checkout',
                });
                history.replace(`/redirect-to?${query.toString()}`);
            }
        };
        window.addEventListener('focus', checkPaymentWindowClosed);
        document.addEventListener('visibilitychange', checkPaymentWindowClosed);
        const pollTimer = setInterval(checkPaymentWindowClosed, 1000);
        return () => {
            window.removeEventListener('focus', checkPaymentWindowClosed);
            document.removeEventListener('visibilitychange', checkPaymentWindowClosed);
            clearInterval(pollTimer);
        };
    }, []);

    let couponParm = {
        checkout: true,
        itemType: itemType,
        itemId: itemId,
        disablePagination: true,
        updatedCourseBilling: true
    };

    const footerRef = useRef(null); // Create a ref for Footer

  const scrollToFooter = () => {
   
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

    useEffect(() => {
        if (invalidCouponType) {
            setDisablePay(true);
        } else {
            setDisablePay(false);
        }
    }, [invalidCouponType])

    // useEffect(() => {
    //     if (selectedCouponCode) {
    //         setPayOfferCode(selectedCouponCode);
    //     } else {
    //         setPayOfferCode(null);
    //     }
    // }, [selectedCouponCode])
    useEffect(() => {
        if (selectedTerm) {
            setIsPayTerm(selectedTerm);
            setStorePayTerm(selectedTerm);
        } else {
            setIsPayTerm(singleBuyNowDetails?.billingPlan)
            setStorePayTerm(singleBuyNowDetails?.billingPlan)
            setSelectedTerm(singleBuyNowDetails?.billingPlan)
        }
    }, [selectedTerm, singleBuyNowDetails?.billingPlan])

    useEffect(() => {
        if (selectedPlan) {
            setPlanName(selectedPlan);
            storeSelectedPlan(selectedPlan);
        } else {
            setPlanName(singleBuyNowDetails?.planName)
            storeSelectedPlan(singleBuyNowDetails?.planName)
        }
    }, [selectedPlan, singleBuyNowDetails?.planName])

    useEffect(() => {
        closeInstallmentModal === true ? setInstallmentVisible(false) : setInstallmentVisible(false);
    }, [closeInstallmentModal]);

    useEffect(() => {
        // setSelectedCouponCode(null);
        togglePageLoader(true);
        const id = itemId || singleBuyNowDetails?.item?.[0]?.id;
        const type = itemType || singleBuyNowDetails?.item?.[0]?.resourceType;

        if (type === 'course' && id) {
            Api.get(`/market/courseDetails`).params({ id, preview: false }).send((response) => {
                if (response && response.course && response.course.batches) {
                    setCourseBatches(response.course.batches);
                    if (response.course.batches.length > 0) {
                        setSelectedBatchId(response.course.batches[0].id);
                    }
                }
            });
        }

        getCheckOutItem(
            id,
            type,
            () => {
                if (promo) {
                    let params = {
                        code: promo,
                        type: 'offer',
                        id,
                        itemType: type,
                    };
                    applyPromoCheckout(params, (res) => {
                        toggleApplyLoader(false);
                        togglePageLoader(false);
                        if (res?.show?.type === 'success') {
                            setInvalidCouponType(null);
                            setPayOfferCode(promo);
                        } else {
                            setPayOfferCode(null);
                        }
                    }, () => {
                        setCouponInCart(true);
                    }, (err) => {
                        // auto-applied promo (not user-typed) failing should not block checkout or show an error
                    });
                } else {
                    togglePageLoader(false);
                }
            })
        // Buy Now pushes to the same /user-checkout route with new location state, so this
        // component is re-rendered but never remounted. Without these deps the checkout item
        // is never refetched and Pay Now would post the previously selected item.
    }, [itemId, itemType])

    function IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    function isHTML(str) {
        var a = document.createElement('div');
        a.innerHTML = str;

        for (var c = a.childNodes, i = c.length; i--;) {
            if (c[i].nodeType === 1) return true;
        }
        return false;
    }
    console.log("selectedTermNaa", selectedCouponCode, payOfferCode)
    useEffect(() => {
        fetchPromoCodes(() => { });
        setCouponInCart(false)
        setStorePromoPrice(null)
        setPayOfferCode(null);
        setSelectedCouponCode(null);
        setTermList(null);
        // promoManuallyRemoved is global, sticky Redux state: the REMOVE buttons set it and
        // nothing clears it, so one removal blocks auto-apply everywhere until a page reload.
        // A fresh visit to checkout is a new promo context, so clear it alongside the rest.
        setPromoManuallyRemoved(false);
        toggleProfileLoader(true);
        getUserProfileDetails(() => { toggleProfileLoader(false); });
    }, []);



    useEffect(() => {
        if (itemId || itemType) {
            setCouponList(null);
            getCouponList(couponParm);
        }
    }, [itemId, itemType])

    const hasAutoAppliedPromoRef = useRef(false);
    useEffect(() => {
        if (hasAutoAppliedPromoRef.current) return;
        if (promo) return; // an explicit promo was already carried via navigation and is handled above
        if (promoManuallyRemoved) return; // user explicitly removed a promo; don't force it back on
        if (!couponList?.items?.length) return;
        const bestCode = getBestPromoCode(couponList?.items, singleBuyNowDetails?.exAmount);
        if (bestCode && !selectedCouponCode && !storePromoPrice) {
            hasAutoAppliedPromoRef.current = true;
            let params = {
                code: bestCode,
                type: 'offer',
                id: itemId || singleBuyNowDetails?.item?.[0]?.id,
                itemType: itemType || singleBuyNowDetails?.item?.[0]?.resourceType,
            };
            applyPromoCheckout(params, () => { }, () => {
                setSelectedCouponCode(bestCode);
            }, (err) => {
                // auto-applied promo (not user-typed) failing should not block or show an error
            });
        }
    }, [couponList, singleBuyNowDetails, storePromoPrice, selectedCouponCode])

    // Switching to a different item while staying on /user-checkout: drop the previous
    // item's promo state, otherwise its coupon keeps pricing the new item and auto-apply
    // stays blocked. Only fires on an actual switch, never on first mount.
    const prevItemKeyRef = useRef(null);
    useEffect(() => {
        const itemKey = `${itemId ?? ''}|${itemType ?? ''}`;
        const isSwitch = prevItemKeyRef.current !== null && prevItemKeyRef.current !== itemKey;
        prevItemKeyRef.current = itemKey;
        if (!isSwitch) return;
        hasAutoAppliedPromoRef.current = false;
        pendingPaymentRef.current = null;
        setSelectedCouponCode(null);
        setStorePromoPrice(null);
        setPayOfferCode(null);
        setCouponInCart(false);
        setInvalidCouponType(null);
        setPromoManuallyRemoved(false);
    }, [itemId, itemType])

    const [isCourseInCart, setIsCourseInCart] = useState(false);

    let foundCourse = false;
    useEffect(() => {
        if (Array.isArray(singleBuyNowDetails?.items)) {

            for (const item of singleBuyNowDetails?.items) {
                if (item?.itemType === "course") {
                    foundCourse = true;
                    break; // Exit the loop once a course is found
                }
            }

            setIsCourseInCart(foundCourse);
        }
    }, [singleBuyNowDetails]);

    // useEffect(() => {
    //     if (singleBuyNowDetails?.item?.[0]?.id) {
    //         setStorePromoPrice(false);
    //     }
    // }, [])

    console.log("storePayTerm", storePayTerm, isPayTerm)
    const CartCard = ({ item, key }) => {
        const [saved, setSaved] = useState({});
        const handleSaveForLater = (id, itemType) => {
            if (saved[id]) {
                removeSaveItem(id, itemType, (res) => {
                    if (res) {
                        setSaved((prevSavedItems) => ({
                            ...prevSavedItems,
                            [id]: false,
                        }));
                    }
                });
            } else {
                postAddSaveItem(id, itemType, (res) => {
                    if (res) {
                        setSaved((prevSavedItems) => ({
                            ...prevSavedItems,
                            [id]: true,
                        }));
                    }
                });
            }
        };
        return (
            <div className='cart-parent-container' >
                <div className='cart-img-card-parent'
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        storeCourseIdAndType("id", item?.id);
                        storeCourseIdAndType("type", item?.resourceType)
                        history.push({
                            pathname: `/resource-details?id=${item?.id}&type=${item?.resourceType}`,
                            state: {
                                id: item?.id,
                                resourceType: item?.resourceType,
                            }
                        })

                    }}>
                    {item?.resourceType == 'studyMaterial' ?
                        (<>
                            <div style={{ height: "100px", paddingTop: '10px' }} >
                                <div style={{ color: "#594099", fontSize: 16, marginLeft: 2, marginTop: "9px", }}>
                                    <img src={require("../../Assets/course/studyMaterialImg.svg").default} style={{ height: 50, width: 50, marginRight: "20px" }} />
                                    {item?.m_count} {item?.m_count <= 1 ? "Material" : "Materials"}
                                    {item?.q_count > 0 ? `, ${item?.q_count} ${item?.q_count <= 1 ? "quiz" : "quizzes"}` : ""}</div>
                            </div>
                        </>) :
                        <img className='cart-img-card' src={item?.image ? `${Api.dlS3Url}${item?.image}` : defaultCourseImage} />

                    }
                    {item?.mode ?
                        <div style={{ fontSize: 10, color: "#FFFFFF", backgroundColor: item?.mode == "online" ? "#28DF99" : item?.mode == "hybrid" ? "#FFA931" : "#FF414D", padding: "3px 6px", position: "absolute", fontWeight: "bold", top: 15, right: 0 }}>{item?.mode?.charAt(0).toUpperCase() + item?.mode?.slice(1)}</div>
                        : <></>}
                    {item?.amount > 0 ? <div className='card-amount-label'>₹ {(parseFloat(item?.amount) - parseFloat(item?.discountAmount)).toFixed(2)}{" "}{item?.discountAmount > 0 ? <span style={{ color: "#FF414D", textDecoration: 'line-through' }}>₹ {parseFloat(item?.amount || 0)}</span> : <></>}</div> : <></>}

                </div>
                <div className='cart-title-parent' >
                    <div className='cart-card-title'>{item?.resourceType == 'course' || item?.resourceType == "videoResource" ? item?.courseName : item?.name}
                        {item?.newTag === "0" ? null :
                            <span className='mobile-new-tag m-l-5'>NEW</span>
                        }
                    </div>
                    <div className='cart-card-description' >
                        <Tooltip overlayClassName='cart-brief-tooltip' title={IsJsonString(item?.brief) ? !IsJsonString(JSON.parse(item?.brief)?.mobile) && isHTML(JSON.parse(item?.brief)?.mobile) ? HtmlParser(JSON.parse(item?.brief)?.mobile) : HtmlParser(JSON.parse(item?.brief)?.mobile) : item?.brief}>
                            {IsJsonString(item?.brief) ? !IsJsonString(JSON.parse(item?.brief)?.mobile) && isHTML(JSON.parse(item?.brief)?.mobile) ? HtmlParser(JSON.parse(item?.brief)?.mobile) : HtmlParser(JSON.parse(item?.brief)?.mobile) : item?.brief}
                        </Tooltip>
                    </div>

                    <div className='r-c-sb m-t-10 mobile-disable'>
                        <div className='r-c-fs' style={{ width: "100%" }} >
                            {item?.bestseller ?
                                <div className='cart-best-seller m-r-10'>Bestseller</div>
                                : null}
                            {item?.rating > 0 ?
                                <div className='r-c-fs '><RatingStars star={item?.rating} />
                                    <span className='m-l-5'>({item?.ratingCount})</span>
                                </div>
                                : null}
                        </div>
                    </div>
                    <div className='mobile-enable'>
                        <div className='cart-seller-btn'  >
                            <div className='cart-best-seller'>Bestseller</div>
                            <div className='mobile-rating'><img className='mobile-star' src={require("../../Assets/aulasMarket/ic-star-fill.svg").default} /><span style={{ color: "#191919", fontWeight: "550" }}>{item?.rating}</span>
                                <span style={{ marginLeft: 3 }}>({item?.ratingCount})</span>
                            </div>
                        </div>
                        <div className="r-c-fe m-l-10">
                            {item?.owned == 1 ? <></> :
                                <span style={{ marginRight: 10, fontWeight: 600, color: "#594099", fontSize: 12, cursor: "pointer" }}>
                                    <img className='cart-delete-outline' onClick={(e) => { e.stopPropagation(); handleSaveForLater(item?.id, item?.resourceType) }} src={saved[item?.id] || item?.inSaved == "1" ? saveFill : saveOutlined} />
                                </span>
                            }
                            {/* <span style={{ fontWeight: 600, color: "#FF414D", fontSize: 12, cursor: "pointer" }}>REMOVE</span> */}
                        </div>
                    </div>
                    {item?.amount > 0 && (
                        <div className='mobile-enable m-t-10 font-bold' style={{ fontSize: 12 }}>
                            ₹ {(parseFloat(item?.amount) - parseFloat(item?.discountAmount)).toFixed(2)}
                            {item?.discountAmount > 0 && (
                                <>
                                    <span style={{ color: '#636363', marginLeft: 5, textDecoration: 'line-through', fontWeight: "normal", fontSize: 10 }}>
                                        ₹ {(parseFloat(item?.amount).toFixed(2))}
                                    </span>
                                    <span style={{ color: "#28DF99", marginLeft: 5, fontSize: 10, fontWeight: "normal", fontSize: 10 }}>{(parseFloat(item?.discountPercent).toFixed(0))}% off</span>
                                </>
                            )}
                        </div>
                    )}
                    <div className='m-t-15 mobile-disable'>
                        <span onClick={() => {
                            postAddSaveForLater(item?.id, item?.resourceType, () => { })
                        }} style={{ marginRight: 20, fontWeight: 'bold', color: "#191919", fontSize: 12, cursor: "pointer" }}>SAVE FOR LATER</span>
                    </div>
                    {item?.resourceType === 'course' && courseBatches && courseBatches.length > 0 && (
                        <div style={{ marginTop: '15px', fontFamily: 'Roboto' }}>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: '#191919', marginBottom: '5px' }}>
                                Select Batch <span style={{ color: 'red' }}>*</span>
                            </div>
                            <div style={{ width: '100%', maxWidth: '280px', border: '1px solid #d9d9d9', borderRadius: '8px', overflow: 'hidden' }}>
                                <Select
                                    bordered={false}
                                    placeholder="Select a batch"
                                    style={{ width: '100%' }}
                                    value={selectedBatchId}
                                    onChange={(value) => setSelectedBatchId(value)}
                                >
                                    {courseBatches.map(batch => (
                                        <Select.Option key={batch.id} value={batch.id}>
                                            {batch.name} (Starts: {moment(batch.startDate).format("DD MMM YYYY")})
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }


    let fromMarket = true;


    const numberWithCommas = (x) => {
        console.log('xx', x);
        return x?.toString().split('.')[0].length > 3 ? x?.toString().substring(0, x.toString().split('.')[0].length - 3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x?.toString().substring(x.toString().split('.')[0].length - 3) : x?.toString();
    }
    const totalAmount = storePromoPrice?.cart?.amount - storePromoPrice?.cart?.discount || storePromoPrice?.amount - storePromoPrice?.discount;
    const totalAmountBeforeDiscount = singleBuyNowDetails?.amount - singleBuyNowDetails?.discount;


    const isLiveParam = {
        userId: user?.id,
        userAccessToken: user?.accessToken
    }
    const checkDiffTotalAmt = couponInCart ? storePromoPrice?.amount : singleBuyNowDetails?.amount || null
    console.log("payOfferCode", isPayTerm, singleBuyNowDetails?.billingPlan)
    console.log("singleBuyNowDetails123", singleBuyNowDetails)

    const isFreeCheckout = storePromoPrice?.totalAmount == 0 || singleBuyNowDetails?.totalAmount == 0;

    const handlePayNow = () => {
        // A free enrolment never reaches the gateway, so only a real payment is gated on the email
        // and billing address the gateway refuses an order without.
        if (!isFreeCheckout && !paymentDetailsRef.current && getMissingPaymentDetails(userDetails).isMissing) {
            setIsPaymentDetailsModal(true);
            return;
        }
        proceedToPayNow(paymentDetailsRef.current);
    }

    const proceedToPayNow = (paymentDetails, savePromise) => {
        // Opened here, synchronously inside the click, so the browser does not treat it as an
        // unsolicited popup. It sits on the loading page for as long as the work below takes.
        payuWindowRef.current = openPayuLoadingWindow(PAYU_WINDOW_NAME);
        togglePaynowLoader(true)
        if (!savePromise) {
            createOrder(paymentDetails);
            return;
        }
        // The address has to be on the profile before the order is created, so the order waits on
        // the save. A failed save aborts the payment rather than sending an unsaved address.
        savePromise.then(() => createOrder(paymentDetails)).catch(() => {
            togglePaynowLoader(false);
            if (payuWindowRef.current && !payuWindowRef.current.closed) {
                payuWindowRef.current.close();
            }
        });
    }

    const createOrder = (paymentDetails) => {
        setValueForCheckout(true)
        togglePaynowLoader(true)
        const billingAddress = formatBillingAddress(paymentDetails?.address || userDetails?.basicprofile?.currentAddress);
        if (singleBuyNowDetails?.item && singleBuyNowDetails.item.length > 0) {
            const firstItem = singleBuyNowDetails.item?.[0] || null;

            if (firstItem?.resourceType === "course" && courseBatches && courseBatches.length > 0 && !selectedBatchId) {
                Notification.error("Error", "Please select a batch to proceed.");
                togglePaynowLoader(false);
                return;
            }

            let paramsCheckPayment = {
                // amount: singleBuyNowDetails?.totalAmount || null,
                amount: storePromoPrice ? storePromoPrice?.totalAmount : singleBuyNowDetails?.totalAmount ? singleBuyNowDetails?.totalAmount : null,
                checkout: true,
                itemId: firstItem?.id,
                itemType: firstItem?.resourceType,
                code:  selectedCouponCode || undefined,
                billingPlan: singleBuyNowDetails?.item?.[0]?.resourceType === "course" ? isPayTerm ? isPayTerm : null : singleBuyNowDetails?.billingPlan,
                updatedCourseBilling: true,
                planName: planName,
                batchId: selectedBatchId || undefined,
                standardId: selectedBatchId || undefined,
            }
            let paramsPay = {
                orderAmount: paramsCheckPayment.amount,
                orderCurrency: 'INR',
                flow: 'market',
                productinfo: firstItem?.resourceType === "course" || firstItem?.resourceType === "videoResource" ? firstItem?.courseName : firstItem?.name,
                promo: selectedCouponCode || '',
                type: singleBuyNowDetails?.item?.[0]?.resourceType,
                id: singleBuyNowDetails?.item?.[0]?.id,
                billingPlan: selectedTerm || null,
                planName: selectedPlan || null,
                customerDetails: {
                    customer_id: user?.id?.toString() || null,
                    customer_name: user?.name || null,
                    // Prefer what the modal collected: the profile has not necessarily been saved
                    // with it, and the gateway needs it on this order regardless.
                    customer_email: paymentDetails?.email || userDetails?.email || user?.email || null,
                    customer_phone: user?.phone?.toString() || null,
                    customer_address: billingAddress || null
                }
            };

            if (isFreeCheckout) {
                if (payuWindowRef.current && !payuWindowRef.current.closed) {
                    payuWindowRef.current.close();
                }
                let paramProcess = {
                    checkout: true,
                    type: paramsCheckPayment?.itemType,
                    id: paramsCheckPayment?.itemId,
                    promo: payOfferCode || selectedCouponCode || undefined,
                    free: true,
                    updatedCourseBilling: true,
                    planName: planName,
                    billingPlan: singleBuyNowDetails?.item?.[0]?.resourceType === "course" ? isPayTerm ? isPayTerm : null : singleBuyNowDetails?.billingPlan,
                    batchId: selectedBatchId || undefined,
                    standardId: selectedBatchId || undefined,
                }

                postCartPayment(paramProcess, () => {
                    togglePaynowLoader(false)
                    if (singleBuyNowDetails?.item?.[0]?.resourceType === "course") {
                        checkLiveCourse(isLiveParam);
                    }
                    // showMenu(true)
                    // history.push("/courses-list")
                    setFromCheckoutPage(true)
                    setShowDownloadAppModal(true)
                    togglePaynowLoader(false)
                },(response)=>{
                  
                })
                togglePaynowLoader(false)

            } else {
                setPromoCode(selectedCouponCode || '');
                getCheckPayment(paramsCheckPayment, (res) => {
                    togglePaynowLoader(false)
                    if (res?.valid) {
                        pendingPaymentRef.current = {
                            promo: selectedCouponCode || '',
                            type: singleBuyNowDetails?.item?.[0]?.resourceType,
                            id: singleBuyNowDetails?.item?.[0]?.id,
                            checkout: true,
                            billingPlan: selectedTerm || null,
                            planName: selectedPlan || null,
                            // The batch the student picked; market assigns it once payment succeeds.
                            standardId: selectedBatchId || undefined,
                            isTest: true,
                        };
                        payNowCart(paramsPay, (response) => {
                            togglePaynowLoader(false)
                            // generatePaymentRequest(response, null, user, fromMarket)
                            // The order id is generated by the backend and comes back as txnid, so
                            // it can only be attached once the order exists. A response without one
                            // is a failure: the poller could not confirm the payment without it.
                            if (response?.txnid) {
                                pendingPaymentRef.current = { ...pendingPaymentRef.current, orderId: response.txnid };
                                redirectToPayU(response, PAYU_WINDOW_NAME)
                            } else {
                                pendingPaymentRef.current = null;
                                if (payuWindowRef.current && !payuWindowRef.current.closed) {
                                    payuWindowRef.current.close();
                                }
                            }
                            togglePaynowLoader(false)
                        }, selectedCouponCode || '')
                    } else {
                        if (payuWindowRef.current && !payuWindowRef.current.closed) {
                            payuWindowRef.current.close();
                        }
                    }
                    togglePaynowLoader(false)
                })

            }
        }
    }
    const handleApplyClick = () => {

        if (singleBuyNowDetails?.item && singleBuyNowDetails.item.length > 0) {
            const firstItem = singleBuyNowDetails.item[0];
            let params = {
                code: payOfferCode,
                type: 'offer',
                id: firstItem?.id,
                itemType: firstItem?.resourceType,
            };
            toggleApplyLoader(true);
            applyPromoCheckout(params, (res) => {
                toggleApplyLoader(false);
                if (res) { setInvalidCouponType(null); setSelectedCouponCode(payOfferCode) } else { setPayOfferCode(null); setSelectedCouponCode(null) }
            }, () => {
                setCouponInCart(true);
                toggleApplyLoader(false)
            }, (err) => {
                if (err.invalid) {
                    setInvalidCouponType(InvalidCouponType.invalid);
                } else if (err.expired) {
                    setInvalidCouponType(InvalidCouponType.expired);
                } else if (err.minPurchase) {
                    setInvalidCouponType(InvalidCouponType.minPurchase);
                } else if (err.usageLimit) {
                    setInvalidCouponType(InvalidCouponType.usageLimit);
                }
            });
        }
    }
    const handleInputCode = (e) => {
        const filteredValue = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Allow only alphanumeric characters
        setPayOfferCode(filteredValue);
        setIsInputTyped(filteredValue.trim() !== '');
        setInvalidCouponType(null);
    }
    const numberOfInstallments = termList?.length || singleBuyNowDetails?.installmentCount || 0;

    // Determine the term to use based on the number of installments
    const installmentTerm = numberOfInstallments === 1 ? 'installment' : 'installments';
    const PriceDetails = () => {
        return (
            <div className='price-parent-container'>
                <div className='cart-price-details-title'>PRICE DETAILS</div>
                <div className='price-border'></div>
                {singleBuyNowDetails?.item?.[0]?.resourceType === "course" ?
                    <>
                        <div className='' style={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}>Pay after registration</div>
                        <div className='r-c-sb cart-price' style={{ padding: "2px 20px" }} >
                            <div>Balance after registration and discount</div>
                            <div>₹{storePromoPrice ? storePromoPrice?.balancePayable?.toLocaleString() : singleBuyNowDetails?.balanceRegistration?.toLocaleString()}</div>
                        </div>
                        {(storePromoPrice ? storePromoPrice?.offerDiscount : singleBuyNowDetails?.offerDiscount) ?
                            <div className='r-c-sb cart-price m-b-10' style={{ padding: "2px 20px" }}>
                                <div>Offer discount</div>
                                <div style={{ color: "#28DF99" }}>₹{storePromoPrice ? storePromoPrice?.offerDiscount?.toLocaleString() : singleBuyNowDetails?.offerDiscount?.toLocaleString()}</div>
                            </div> : null}
                        {/* <div className='cart-discount' style={{ padding: "2px 20px" }}>Promo discount
                            <span style={{ color: "#28DF99" }}>
                                ₹0
                            </span>
                        </div>
                        <div className='r-c-sb cart-price' style={{ padding: "2px 20px" }} >
                            <div>Payable after discount</div>
                            <div>₹9500</div>
                        </div> */}
                        {storePromoPrice ? <>
                            {isPayTerm ?
                                <>{storePromoPrice?.courseBilling?.length > 0 ?
                                    <div className='r-c-sb cart-price' style={{ padding: "2px 20px" }} >
                                        <div>Payment term</div>
                                        <div>{isPayTerm}</div>
                                    </div>
                                    : null}

                                    <div className='r-c-sb m-b-10'>
                                        <div className='' onClick={() => { setInstallmentVisible(true) }} style={{ padding: "2px 20px", color: "#594099", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>EDIT PLAN</div>
                                        <div className='' style={{ padding: "2px 20px", color: "#636363", fontWeight: 600 }}>
                                            {storePromoPrice?.courseBilling?.length > 0 ?
                                                <>
                                                    ({termList?.length || singleBuyNowDetails?.installmentCount} {installmentTerm})
                                                </>
                                                : null}
                                            {/* ({termList?.length || singleBuyNowDetails?.installmentCount} {installmentTerm}) */}
                                        </div>
                                    </div>

                                </> : <></>
                            }
                        </> : <>
                            {isPayTerm ?
                                <>
                                    <div className='r-c-sb cart-price' style={{ padding: "2px 20px" }} >
                                        <div>Payment term</div>
                                        <div>{isPayTerm}</div>
                                    </div>
                                    {singleBuyNowDetails?.installmentCount ?
                                        <div className='r-c-sb m-b-10'>
                                            <div className='' onClick={() => { setInstallmentVisible(true) }} style={{ padding: "2px 20px", color: "#594099", fontSize: "12px", fontWeight: "bold", cursor: "pointer" }}>EDIT PLAN</div>
                                            <div className='' style={{ padding: "2px 20px", color: "#636363", fontWeight: 600 }}>
                                                ({termList?.length || singleBuyNowDetails?.installmentCount} {installmentTerm})
                                            </div>
                                        </div>
                                        : <></>}
                                </> : <></>
                            }
                        </>}
                        <div className='price-border'></div>
                        <div className='' style={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}>Pay now to register</div>
                        <div className='r-c-sb cart-price' style={{ padding: "2px 20px" }} >
                            <div>Registration Fee</div>
                            <div>₹{singleBuyNowDetails?.exAmount?.toLocaleString()}</div>
                        </div>
                        {singleBuyNowDetails?.isGSTEnabled ?
                            <div className='r-c-sb cart-price m-b-10' style={{ padding: "2px 20px" }} >
                                <div>GST</div>
                                <div>+₹{storePromoPrice ? storePromoPrice?.gst?.toLocaleString() : singleBuyNowDetails?.gst?.toLocaleString()}</div>
                            </div>
                            : null}
                        {/*                 
                <div className='cart-price'>{singleBuyNowDetails?.item?.[0]?.resourceType === "course" ? "Registration fee" : "Price"}
                    <span>₹{couponInCart ? numberWithCommas(storePromoPrice?.cart?.amount?.toFixed(2) || storePromoPrice?.amount?.toFixed(2)) : numberWithCommas(singleBuyNowDetails?.amount?.toFixed(2))}</span>
                </div> */}
                        <div className='price-border'></div>
                        <div className='cart-total-amount'>Payable now <br></br> (Registration fee)
                            <span>
                                ₹{singleBuyNowDetails?.totalAmount?.toLocaleString()}
                            </span>
                        </div>
                    </>
                    :
                    <>
                        <div className='cart-price'>{"Price"}
                            <span>₹{storePromoPrice ? storePromoPrice?.amount?.toLocaleString() : singleBuyNowDetails?.exAmount?.toLocaleString()}</span>
                        </div>
                        <div className='cart-discount'>Discount
                            <span>
                                -&nbsp;₹{storePromoPrice ? storePromoPrice?.eDiscountEx?.toLocaleString() : singleBuyNowDetails?.eDiscountEx?.toLocaleString()}
                            </span>
                        </div>
                        {storePromoPrice?.offerDiscountEx || singleBuyNowDetails?.offerDiscountEx ?
                            <div className='cart-discount'>Offer Discount
                                <span style={{ color: "#28DF99" }}>
                                    -&nbsp;₹{(storePromoPrice?.offerDiscountEx || singleBuyNowDetails?.offerDiscountEx)?.toLocaleString() || '0'}
                                </span>
                            </div> : null
                        }
                        {singleBuyNowDetails?.isGSTEnabled ?
                            <div className='r-c-sb cart-price m-b-10'  >
                                <div>GST</div>
                                <div>+&nbsp;₹{storePromoPrice ? storePromoPrice?.gst?.toLocaleString() : singleBuyNowDetails?.gst?.toLocaleString()}</div>
                            </div> : null}
                        <div className='price-border'></div>
                        <div className='cart-total-amount'>Total amount
                            <span>
                                <span>
                                    ₹{storePromoPrice ? storePromoPrice?.totalAmount?.toLocaleString() : singleBuyNowDetails?.totalAmount?.toLocaleString()}
                                </span>
                            </span>
                        </div>
                    </>
                }

                <div className='price-border'></div>
            </div >
        )
    }
    const [showMobDiscount, setShowMobDiscount] = useState(true)
    const [isCategoryClicked, setIsCategoryClicked] = useState(false);
    const [isProfileClicked, setIsProfileClicked] = useState(false);
    const CalculateMarginTop = () => {
        const margins = {
            isDownloadBarVisible: 55,
            showContactBar: 55,
            isOfferBarVisible: 60,
            isMinOfferVisible: 55,
        }
        return 60 + (isDownloadBarVisible ? margins.isDownloadBarVisible : 0) +
            (showContactBar ? margins.showContactBar : 0) +
            (isOffersBarVisible ? margins.isOfferBarVisible : 0);
    }
    return (
        <div onClick={(e) => { e.stopPropagation(); setIsCategoryClicked(false); setIsProfileClicked(false) }} style={{ marginTop: window.innerWidth > 800 ? CalculateMarginTop() : 0 }}>
            <div className='mobile-topbar-parent'>
                <TopBar isOffersBarVisible={isOffersBarVisible} offersCarouselData={offersCarouselData} isCategoryClicked={isCategoryClicked} setIsCategoryClicked={setIsCategoryClicked} isProfileClicked={isProfileClicked} setIsProfileClicked={setIsProfileClicked} />
            </div>
            <div className='mobile-header-parent'>
                <MobilePageHeader title={"Check Out"} onBackPress={() => { history.goBack() }} sider={true} />
            </div>
            <OfferCarouselV2 offersCarouselData={offersCarouselData} onDownloadClick={scrollToFooter} fromHomePage={false} fromStudentCart={false} fromCourseDetailsPage={false}/>
            <div style={{ backgroundColor: "#FAFAFA", minHeight: "calc(100vh - 50px)" }}>
                {/* <OffersCarousel />
                {showMobDiscount && offersCarouselData?.length > 0 ?
                    <MobileDiscountOffersCarousel setShowMobDiscount={setShowMobDiscount} />
                    :
                    <></>
                } */}
                <div className='student-cart-parent'>
                    <div className='mobile-cart-header m-b-10'>Checkout</div>
                    {/* <div className='empty-cart-parent'>
                        <EmptyCart />
                    </div> */}

                    <div className='mobile-flex-price'>
                        <div className='student-cart-child'>
                            <div className='cart-course-container'>
                                <div className='save-card-border'>
                                    {singleBuyNowDetails?.item?.map((item) => {
                                        return (
                                            <CartCard item={item} />
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='cart-price-details'>
                                <PriceDetails />
                                <div className='price-coupon-field' style={{ fontFamily: "Roboto" }}>
                                    {storePromoPrice ?
                                        <div className='price-applied' style={{ alignItems: "flex-start" }}>
                                            <div className='r-c-c'><img style={{ marginTop: -20 }} src={require("../../Assets/aulasMarket/ic-check-filled.svg").default} />
                                                <div className='r-sfa m-l-10'>
                                                    <div style={{ color: "#191919", fontSize: 13, fontWeight: "600" }}>You saved ₹{storePromoPrice?.promoDiscount || singleBuyNowDetails?.promoDiscount} with this code</div>
                                                    <div style={{ color: "#AEAEAE", fontSize: 12 }}>Promotional offer Applied</div>
                                                </div>
                                            </div>
                                            <div style={{ color: '#FF414D', cursor: 'pointer', marginLeft: 5, fontWeight: "500" }} onClick={() => { setCouponInCart(false); setPayOfferCode(null); setSelectedCouponCode(false); setStorePromoPrice(false); setIsInputTyped(false); setPromoManuallyRemoved(true) }}>REMOVE</div>


                                        </div>
                                        :
                                        <div className=' r-c-c' style={{ display: 'flex' }}>
                                            <Input
                                                className='price-coupon-filed'
                                                type="text"
                                                placeholder='Enter promotional offer'
                                                onChange={(val) => { handleInputCode(val) }}
                                                value={payOfferCode}
                                                style={{ height: "4.5vh", }}

                                            ></Input>
                                            <Button
                                                loading={applyLoader}
                                                className='r-c-c text-xm bold-600'
                                                type="button"
                                                onClick={handleApplyClick}
                                                style={{
                                                    cursor: isInputTyped ? 'pointer' : 'not-allowed',
                                                    border: ` 1px solid #594099 ${isInputTyped ? 1 : 0.4}`,
                                                    borderRadius: " 0px 4px 4px 0px",
                                                    backgroundColor: isInputTyped ? "#594099" : "white",
                                                    padding: '5px 10px',
                                                    color: isInputTyped ? "white" : "#594099",
                                                    height: "4.5vh",
                                                    opacity: isInputTyped ? 1 : 0.4
                                                }}
                                                disabled={!isInputTyped}
                                            >
                                                APPLY
                                            </Button>
                                        </div>

                                    }
                                    {invalidCouponType ?
                                        <div style={{ color: "red", fontWeight: "normal" }}>{InvalidCouponMessage[invalidCouponType] || ''}</div>
                                        : null}
                                    {storePromoPrice || ( singleBuyNowDetails?.item?.[0]?.resourceType == "course" ? singleBuyNowDetails?.balanceRegistration == 0  : singleBuyNowDetails?.totalAmount == 0) ? <></> : couponList?.items?.length > 0 && singleBuyNowDetails?.balanceRegistration !== 0 ? <div onClick={() => { setIsCouponModal(true) }} style={{ fontSize: "13px", fontWeight: "bold", fontWeight: "bold", color: "#1089FF", cursor: "pointer", marginTop: 10 }}>VIEW ALL PROMOTIONAL OFFERS</div> : <></>}
                                </div>
                                {
                                    !couponList?.minOffers?.length ? <></> : (<>
                                        <div className='cart-diffrence-amount'>
                                            Add items worth ₹{couponList?.minOffers?.[0]?.dif?.toLocaleString() || ''} to get {couponList?.minOffers?.[0]?.discountType == 'percent' ? `${couponList?.minOffers?.[0]?.discount}%` : `₹${couponList?.minOffers?.[0]?.discount}`} off above ₹{couponList?.minOffers?.[0]?.minPurchase?.toLocaleString()}
                                        </div>
                                    </>)
                                }
                                {
                                    singleBuyNowDetails?.item?.[0]?.resourceType !== "course" ? <></> : (<>
                                        <div className='checkout-disclaimer'>
                                            This is the registration fee for the course, the total fees will be collected as per the fee plan
                                        </div>
                                    </>)
                                }
                                {
                                    (storePromoPrice ? !storePromoPrice?.discount : !singleBuyNowDetails?.discount) ? <></> : (<>
                                        <div className='cart-diffrence-amount'>
                                            Your total savings on this purchase is ₹ {storePromoPrice ? storePromoPrice?.discount?.toLocaleString() : singleBuyNowDetails?.discount?.toLocaleString()}
                                        </div>
                                    </>)
                                }
                                <div className='r-c-c m-t-20'>
                                    <Button
                                        type="primary"
                                        disabled={disablePay || profileLoader}
                                        loading={paynowLoader || profileLoader}
                                        onClick={() => handlePayNow()}
                                    >
                                        {!couponInCart ? (totalAmountBeforeDiscount === 0 ? "ENROLL NOW" : singleBuyNowDetails?.item?.[0]?.resourceType === "course" ? "PAY NOW" : "PAY NOW") : (totalAmount === 0 ? "ENROLL NOW" : "PAY NOW")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className='mobile-price-enable'>
                            <MobileCheckOut isPayTerm={isPayTerm} termList={termList} />
                        </div>
                    </div>
                    <CouponsModal
                        isCouponModal={isCouponModal}
                        setIsCouponModal={setIsCouponModal}
                        from={"checkout"}
                        setPayOfferCode={setPayOfferCode}
                        singleBuyNowDetails={singleBuyNowDetails}
                        setInvalidCouponType={setInvalidCouponType}
                    />
                    {isInstallmentVisible &&
                        <CourseInstallmentModal
                            isInstallmentVisible={isInstallmentVisible}
                            setInstallmentVisible={setInstallmentVisible}
                            singleCourseDetailsDataContainer={singleBuyNowDetails?.item?.[0]}
                            from="checkout"

                        />
                    }
                    {showDownloadAppModal &&
                        <DownloadAppModal
                            showDownloadAppModal={showDownloadAppModal}
                            setShowDownloadAppModal={setShowDownloadAppModal}
                            userMarketPlaceHomeData={userMarketPlaceHomeData}
                            fromCheckoutPage={fromCheckoutPage}
                        />}
                    {isPaymentDetailsModal &&
                        <PaymentDetailsModal
                            visible={isPaymentDetailsModal}
                            onCancel={() => setIsPaymentDetailsModal(false)}
                            onProceed={(details, savePromise) => {
                                paymentDetailsRef.current = details;
                                setIsPaymentDetailsModal(false);
                                proceedToPayNow(details, savePromise);
                            }}
                        />}
                    <PageDataLoader visible={pageLoader} />
                </div>
            </div>
            <div ref={footerRef}>
            <NewFooter/>
            </div>

        </div>
    )
}



const mapStateToProps = (state) => {
    const { promoCodeDetials, storePayTerm, cartDetails, couponList, selectedCouponCode, couponInCart, storePromoPrice, singleBuyNowDetails, offersCarouselData, isDownloadBarVisible, showContactBar, selectedTerm, termList, isOffersBarVisible, userMarketPlaceHomeData, selectedPlan, promoManuallyRemoved } = state.studentMarketPlace
    const { user } = state.session
    const { userDetails } = state.profileNew
    return { promoCodeDetials, storePayTerm, cartDetails, couponList, selectedCouponCode, user, couponInCart, storePromoPrice, singleBuyNowDetails, offersCarouselData, isDownloadBarVisible, showContactBar, selectedTerm, termList, isOffersBarVisible, userMarketPlaceHomeData, selectedPlan, userDetails, promoManuallyRemoved }
};

const mapDispatchToProps = (dispatch) => ({
    checkLiveCourse: (param) => dispatch(checkLiveCourse(param)),
    getUserProfileDetails: (callback) => dispatch(getUserProfileDetails(callback)),
    fetchPromoCodes: (callback) => dispatch(fetchPromoCodes(callback)),
    getCouponList: (param) => dispatch(getCouponList(param)),
    applyPromoCheckout: (params, callback, succesCallback,errorCallback) => dispatch(applyPromoCheckout(params, callback, succesCallback,errorCallback)),
    payNowCart: (params, callback, promo) => dispatch(payNowCart(params, callback, null, promo)),
    setCouponInCart: res => dispatch(setCouponInCart(res)),
    postAddSaveForLater: (id, itemType, callback) => dispatch(postAddSaveForLater(id, itemType, callback)),
    getCheckPayment: (param, callback) => dispatch(getCheckPayment(param, callback)),
    postCartPayment: (param, callback,succesCallback) => dispatch(postCartPayment(param, callback, succesCallback)),
    postAddSaveItem: (id, itemType, callback) => dispatch(postAddSaveItem(id, itemType, callback)),
    removeSaveItem: (id, itemType, callback) => dispatch(removeSaveItem(id, itemType, callback)),
    showMenu: (bool) => dispatch(showMenu(bool)),
    setValueForCheckout: (val) => dispatch(setValueForCheckout(val)),
    setSelectedCouponCode: (val) => dispatch(setSelectedCouponCode(val)),
    setCouponList: (val) => dispatch(setCouponList(val)),
    setPromoManuallyRemoved: (val) => dispatch(setPromoManuallyRemoved(val)),
    getCheckOutItem: (id, itemType, callback) => dispatch(getCheckOutItem(id, itemType, callback)),
    storeCourseIdAndType: (key, val) => dispatch(storeCourseIdAndType(key, val)),
    setStorePromoPrice: (val) => dispatch(setStorePromoPrice(val)),
    setTermList: (val) => dispatch(setTermList(val)),
    setStorePayTerm: (val) => dispatch(setStorePayTerm(val)),
    setSelectedTerm: (val) => dispatch(setSelectedTerm(val)),
    storeSelectedPlan: (val) => dispatch(storeSelectedPlan(val)),
    setPromoCode: (val) => dispatch(setPromoCode(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentCheckOut)